import type {ImageFileConstraints} from '@/shared/application/validators/image-file.validator';
import {MEBIBYTE} from '@/shared/lib/image-preprocessing';

/** Mirrors the server defaults `ANALYSIS_IMAGE_MAX_BYTES` and `ANALYSIS_IMAGE_MAX_COUNT`. */
export const attachmentUploadConfig: ImageFileConstraints & {readonly maxCount: number} = {
  acceptedMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
  maxBytes: 8 * MEBIBYTE,
  maxCount: 4,
};
